import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 100px;
	left: 30px;
`;

const StyledCategoriesContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 10px;
	user-select: none;
`;

const StyledChatContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 6px;
	width: 293px;
	height: 262px;
	margin-top: 20px;
	padding-top: 2px;
	overflow-y: scroll;
	transition: opacity 0.3s ease;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledTagContainer = styled.div`
	position: relative;
	top: -2px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	height: 20px;
	margin-right: 6px;
	padding: 0 6px;
	border-radius: 6px;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 700;
	font-size: 10px;
	line-height: 11px;
	background-color: red;
	color: #ffffff;
	text-transform: uppercase;
	user-select: none;
`;

export {
	StyledCategoriesContainer,
	StyledChatContainer,
	StyledContainer,
	StyledTagContainer,
};
